"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8440],{

/***/ 88440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tooltip_Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@reach/auto-id/dist/reach-auto-id.esm.js
var reach_auto_id_esm = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@reach/utils/owner-document/dist/reach-utils-owner-document.esm.js
var reach_utils_owner_document_esm = __webpack_require__(55152);
;// CONCATENATED MODULE: ./node_modules/@reach/utils/get-document-dimensions/dist/reach-utils-get-document-dimensions.esm.js



/**
 * Get the size of the working document minus the scrollbar offset.
 *
 * @param element
 */

function getDocumentDimensions(element) {
  var _ownerDocument$docume, _ownerDocument$docume2;

  var ownerDocument = (0,reach_utils_owner_document_esm/* getOwnerDocument */.r)(element);
  var ownerWindow = ownerDocument.defaultView || window;

  if (!ownerDocument) {
    return {
      width: 0,
      height: 0
    };
  }

  return {
    width: (_ownerDocument$docume = ownerDocument.documentElement.clientWidth) != null ? _ownerDocument$docume : ownerWindow.innerWidth,
    height: (_ownerDocument$docume2 = ownerDocument.documentElement.clientHeight) != null ? _ownerDocument$docume2 : ownerWindow.innerHeight
  };
}



// EXTERNAL MODULE: ./node_modules/@reach/utils/make-id/dist/reach-utils-make-id.esm.js
var reach_utils_make_id_esm = __webpack_require__(94411);
// EXTERNAL MODULE: ./node_modules/@reach/utils/dev-utils/dist/reach-utils-dev-utils.esm.js
var reach_utils_dev_utils_esm = __webpack_require__(40884);
// EXTERNAL MODULE: ./node_modules/@reach/utils/compose-refs/dist/reach-utils-compose-refs.esm.js
var reach_utils_compose_refs_esm = __webpack_require__(61331);
// EXTERNAL MODULE: ./node_modules/@reach/utils/compose-event-handlers/dist/reach-utils-compose-event-handlers.esm.js
var reach_utils_compose_event_handlers_esm = __webpack_require__(24683);
// EXTERNAL MODULE: ./node_modules/@reach/portal/dist/reach-portal.esm.js
var reach_portal_esm = __webpack_require__(14921);
;// CONCATENATED MODULE: ./node_modules/@reach/visually-hidden/dist/reach-visually-hidden.esm.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["as", "style"];

/**
 * VisuallyHidden
 *
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the `aria-hidden` attribute.
 */
var VisuallyHidden = /*#__PURE__*/(0,react.forwardRef)(function VisuallyHidden(_ref, ref) {
  var _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "span" : _ref$as,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/(0,react.createElement)(Comp, _extends({
    ref: ref,
    style: _extends({
      border: 0,
      clip: "rect(0 0 0 0)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
      whiteSpace: "nowrap",
      wordWrap: "normal"
    }, style)
  }, props));
});
/**
 * @see Docs https://reach.tech/visually-hidden#visuallyhidden-props
 */

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ var reach_visually_hidden_esm = ((/* unused pure expression or super */ null && (VisuallyHidden)));


// EXTERNAL MODULE: ./node_modules/@reach/rect/dist/reach-rect.esm.js + 1 modules
var reach_rect_esm = __webpack_require__(5977);
;// CONCATENATED MODULE: ./node_modules/@reach/tooltip/dist/reach-tooltip.esm.js














function reach_tooltip_esm_extends() {
  reach_tooltip_esm_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return reach_tooltip_esm_extends.apply(this, arguments);
}

function reach_tooltip_esm_objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var reach_tooltip_esm_excluded = (/* unused pure expression or super */ null && (["children", "label", "ariaLabel", "id", "DEBUG_STYLE"])),
    _excluded2 = ["label", "ariaLabel", "isVisible", "id"],
    _excluded3 = ["ariaLabel", "aria-label", "as", "id", "isVisible", "label", "position", "style", "triggerRect"],
    _excluded4 = ["type"];

var _on, _on2, _on3, _on4, _on5, _states;
var MOUSE_REST_TIMEOUT = 100;
var LEAVE_TIMEOUT = 500; ////////////////////////////////////////////////////////////////////////////////
// States

var TooltipStates; ////////////////////////////////////////////////////////////////////////////////
// Events

(function (TooltipStates) {
  TooltipStates["Idle"] = "IDLE";
  TooltipStates["Focused"] = "FOCUSED";
  TooltipStates["Visible"] = "VISIBLE";
  TooltipStates["LeavingVisible"] = "LEAVING_VISIBLE";
  TooltipStates["Dismissed"] = "DISMISSED";
})(TooltipStates || (TooltipStates = {}));

var TooltipEvents;

(function (TooltipEvents) {
  TooltipEvents["Blur"] = "BLUR";
  TooltipEvents["Focus"] = "FOCUS";
  TooltipEvents["GlobalMouseMove"] = "GLOBAL_MOUSE_MOVE";
  TooltipEvents["MouseDown"] = "MOUSE_DOWN";
  TooltipEvents["MouseEnter"] = "MOUSE_ENTER";
  TooltipEvents["MouseLeave"] = "MOUSE_LEAVE";
  TooltipEvents["MouseMove"] = "MOUSE_MOVE";
  TooltipEvents["Rest"] = "REST";
  TooltipEvents["SelectWithKeyboard"] = "SELECT_WITH_KEYBOARD";
  TooltipEvents["TimeComplete"] = "TIME_COMPLETE";
})(TooltipEvents || (TooltipEvents = {}));

var chart = {
  initial: TooltipStates.Idle,
  states: (_states = {}, _states[TooltipStates.Idle] = {
    enter: clearContextId,
    on: (_on = {}, _on[TooltipEvents.MouseEnter] = TooltipStates.Focused, _on[TooltipEvents.Focus] = TooltipStates.Visible, _on)
  }, _states[TooltipStates.Focused] = {
    enter: startRestTimer,
    leave: clearRestTimer,
    on: (_on2 = {}, _on2[TooltipEvents.MouseMove] = TooltipStates.Focused, _on2[TooltipEvents.MouseLeave] = TooltipStates.Idle, _on2[TooltipEvents.MouseDown] = TooltipStates.Dismissed, _on2[TooltipEvents.Blur] = TooltipStates.Idle, _on2[TooltipEvents.Rest] = TooltipStates.Visible, _on2)
  }, _states[TooltipStates.Visible] = {
    on: (_on3 = {}, _on3[TooltipEvents.Focus] = TooltipStates.Focused, _on3[TooltipEvents.MouseEnter] = TooltipStates.Focused, _on3[TooltipEvents.MouseLeave] = TooltipStates.LeavingVisible, _on3[TooltipEvents.Blur] = TooltipStates.LeavingVisible, _on3[TooltipEvents.MouseDown] = TooltipStates.Dismissed, _on3[TooltipEvents.SelectWithKeyboard] = TooltipStates.Dismissed, _on3[TooltipEvents.GlobalMouseMove] = TooltipStates.LeavingVisible, _on3)
  }, _states[TooltipStates.LeavingVisible] = {
    enter: startLeavingVisibleTimer,
    leave: function leave() {
      clearLeavingVisibleTimer();
      clearContextId();
    },
    on: (_on4 = {}, _on4[TooltipEvents.MouseEnter] = TooltipStates.Visible, _on4[TooltipEvents.Focus] = TooltipStates.Visible, _on4[TooltipEvents.TimeComplete] = TooltipStates.Idle, _on4)
  }, _states[TooltipStates.Dismissed] = {
    leave: function leave() {
      clearContextId();
    },
    on: (_on5 = {}, _on5[TooltipEvents.MouseLeave] = TooltipStates.Idle, _on5[TooltipEvents.Blur] = TooltipStates.Idle, _on5)
  }, _states)
};
/*
 * Chart context allows us to persist some data around, in Tooltip all we use
 * is the id of the current tooltip being interacted with.
 */

var state = {
  value: chart.initial,
  context: {
    id: null
  }
}; ////////////////////////////////////////////////////////////////////////////////
// Subscriptions:
//
// We could require apps to render a <TooltipProvider> around the app and use
// React context to notify Tooltips of changes to our state machine, instead
// we manage subscriptions ourselves and simplify the Tooltip API.
//
// Maybe if default context could take a hook (instead of just a static value)
// that was rendered at the root for us, that'd be cool! But it doesn't.

var subscriptions = [];

function subscribe(fn) {
  subscriptions.push(fn);
  return function () {
    subscriptions.splice(subscriptions.indexOf(fn), 1);
  };
}

function notify() {
  subscriptions.forEach(function (fn) {
    return fn(state);
  });
} ////////////////////////////////////////////////////////////////////////////////
// Timeouts:
// Manages when the user "rests" on an element. Keeps the interface from being
// flashing tooltips all the time as the user moves the mouse around the screen.


var restTimeout;

function startRestTimer() {
  window.clearTimeout(restTimeout);
  restTimeout = window.setTimeout(function () {
    send({
      type: TooltipEvents.Rest
    });
  }, MOUSE_REST_TIMEOUT);
}

function clearRestTimer() {
  window.clearTimeout(restTimeout);
} // Manages the delay to hide the tooltip after rest leaves.


var leavingVisibleTimer;

function startLeavingVisibleTimer() {
  window.clearTimeout(leavingVisibleTimer);
  leavingVisibleTimer = window.setTimeout(function () {
    return send({
      type: TooltipEvents.TimeComplete
    });
  }, LEAVE_TIMEOUT);
}

function clearLeavingVisibleTimer() {
  window.clearTimeout(leavingVisibleTimer);
} // allows us to come on back later w/o entering something else first after the
// user leaves or dismisses


function clearContextId() {
  state.context.id = null;
} ////////////////////////////////////////////////////////////////////////////////

/**
 * useTooltip
 *
 * @param params
 */


function useTooltip(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      idProp = _ref.id,
      onPointerEnter = _ref.onPointerEnter,
      onPointerMove = _ref.onPointerMove,
      onPointerLeave = _ref.onPointerLeave,
      onPointerDown = _ref.onPointerDown,
      onMouseEnter = _ref.onMouseEnter,
      onMouseMove = _ref.onMouseMove,
      onMouseLeave = _ref.onMouseLeave,
      onMouseDown = _ref.onMouseDown,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onKeyDown = _ref.onKeyDown,
      disabled = _ref.disabled,
      forwardedRef = _ref.ref,
      DEBUG_STYLE = _ref.DEBUG_STYLE;

  var id = String((0,reach_auto_id_esm/* useId */.M)(idProp));

  var _React$useState = (0,react.useState)(DEBUG_STYLE ? true : isTooltipVisible(id, true)),
      isVisible = _React$useState[0],
      setIsVisible = _React$useState[1]; // hopefully they always pass a ref if they ever pass one


  var ownRef = (0,react.useRef)(null);
  var ref = (0,reach_utils_compose_refs_esm/* useComposedRefs */.e)(forwardedRef, ownRef);
  var triggerRect = (0,reach_rect_esm/* useRect */.EL)(ownRef, {
    observe: isVisible
  });
  (0,react.useEffect)(function () {
    return subscribe(function () {
      setIsVisible(isTooltipVisible(id));
    });
  }, [id]);
  (0,reach_utils_dev_utils_esm/* useCheckStyles */.kG)("tooltip");
  (0,react.useEffect)(function () {
    var ownerDocument = (0,reach_utils_owner_document_esm/* getOwnerDocument */.r)(ownRef.current);

    function listener(event) {
      if ((event.key === "Escape" || event.key === "Esc") && state.value === TooltipStates.Visible) {
        send({
          type: TooltipEvents.SelectWithKeyboard
        });
      }
    }

    ownerDocument.addEventListener("keydown", listener);
    return function () {
      return ownerDocument.removeEventListener("keydown", listener);
    };
  }, []);
  useDisabledTriggerOnSafari({
    disabled: disabled,
    isVisible: isVisible,
    ref: ownRef
  });

  function wrapMouseEvent(theirHandler, ourHandler) {
    // Use internal MouseEvent handler only if PointerEvent is not supported
    if (typeof window !== "undefined" && "PointerEvent" in window) {
      return theirHandler;
    }

    return (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(theirHandler, ourHandler);
  }

  function wrapPointerEventHandler(handler) {
    return function onPointerEvent(event) {
      // Handle pointer events only from mouse device
      if (event.pointerType !== "mouse") {
        return;
      }

      handler(event);
    };
  }

  function handleMouseEnter() {
    send({
      type: TooltipEvents.MouseEnter,
      id: id
    });
  }

  function handleMouseMove() {
    send({
      type: TooltipEvents.MouseMove,
      id: id
    });
  }

  function handleMouseLeave() {
    send({
      type: TooltipEvents.MouseLeave
    });
  }

  function handleMouseDown() {
    // Allow quick click from one tool to another
    if (state.context.id === id) {
      send({
        type: TooltipEvents.MouseDown
      });
    }
  }

  function handleFocus() {
    // @ts-ignore
    if (window.__REACH_DISABLE_TOOLTIPS) {
      return;
    }

    send({
      type: TooltipEvents.Focus,
      id: id
    });
  }

  function handleBlur() {
    // Allow quick click from one tool to another
    if (state.context.id === id) {
      send({
        type: TooltipEvents.Blur
      });
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Enter" || event.key === " ") {
      send({
        type: TooltipEvents.SelectWithKeyboard
      });
    }
  }

  var trigger = {
    // The element that triggers the tooltip references the tooltip element with
    // `aria-describedby`.
    // https://www.w3.org/TR/wai-aria-practices-1.2/#tooltip
    "aria-describedby": isVisible ? (0,reach_utils_make_id_esm/* makeId */.q)("tooltip", id) : undefined,
    "data-state": isVisible ? "tooltip-visible" : "tooltip-hidden",
    "data-reach-tooltip-trigger": "",
    ref: ref,
    onPointerEnter: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onPointerEnter, wrapPointerEventHandler(handleMouseEnter)),
    onPointerMove: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onPointerMove, wrapPointerEventHandler(handleMouseMove)),
    onPointerLeave: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onPointerLeave, wrapPointerEventHandler(handleMouseLeave)),
    onPointerDown: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onPointerDown, wrapPointerEventHandler(handleMouseDown)),
    onMouseEnter: wrapMouseEvent(onMouseEnter, handleMouseEnter),
    onMouseMove: wrapMouseEvent(onMouseMove, handleMouseMove),
    onMouseLeave: wrapMouseEvent(onMouseLeave, handleMouseLeave),
    onMouseDown: wrapMouseEvent(onMouseDown, handleMouseDown),
    onFocus: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onFocus, handleFocus),
    onBlur: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onBlur, handleBlur),
    onKeyDown: (0,reach_utils_compose_event_handlers_esm/* composeEventHandlers */.M)(onKeyDown, handleKeyDown)
  };
  var tooltip = {
    id: id,
    triggerRect: triggerRect,
    isVisible: isVisible
  };
  return [trigger, tooltip, isVisible];
} ////////////////////////////////////////////////////////////////////////////////

/**
 * Tooltip
 *
 * @see Docs https://reach.tech/tooltip#tooltip
 */


var Tooltip = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function (_ref2, forwardedRef) {
  var children = _ref2.children,
      label = _ref2.label,
      DEPRECATED_ariaLabel = _ref2.ariaLabel,
      id = _ref2.id,
      DEBUG_STYLE = _ref2.DEBUG_STYLE,
      props = reach_tooltip_esm_objectWithoutPropertiesLoose(_ref2, reach_tooltip_esm_excluded);

  var child = Children.only(children);
   false ? 0 : void 0; // We need to pass some properties from the child into useTooltip
  // to make sure users can maintain control over the trigger's ref and events

  var _useTooltip = useTooltip({
    id: id,
    onPointerEnter: child.props.onPointerEnter,
    onPointerMove: child.props.onPointerMove,
    onPointerLeave: child.props.onPointerLeave,
    onPointerDown: child.props.onPointerDown,
    onMouseEnter: child.props.onMouseEnter,
    onMouseMove: child.props.onMouseMove,
    onMouseLeave: child.props.onMouseLeave,
    onMouseDown: child.props.onMouseDown,
    onFocus: child.props.onFocus,
    onBlur: child.props.onBlur,
    onKeyDown: child.props.onKeyDown,
    disabled: child.props.disabled,
    ref: child.ref,
    DEBUG_STYLE: DEBUG_STYLE
  }),
      trigger = _useTooltip[0],
      tooltip = _useTooltip[1];

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(child, trigger), /*#__PURE__*/createElement(TooltipPopup, reach_tooltip_esm_extends({
    ref: forwardedRef,
    label: label,
    "aria-label": DEPRECATED_ariaLabel
  }, tooltip, props)));
})));

if (false) {} ////////////////////////////////////////////////////////////////////////////////

/**
 * TooltipPopup
 *
 * @see Docs https://reach.tech/tooltip#tooltippopup
 */


var TooltipPopup = /*#__PURE__*/(0,react.forwardRef)(function TooltipPopup(_ref3, forwardRef) {
  var label = _ref3.label,
      DEPRECATED_ariaLabel = _ref3.ariaLabel,
      isVisible = _ref3.isVisible,
      id = _ref3.id,
      props = reach_tooltip_esm_objectWithoutPropertiesLoose(_ref3, _excluded2);

  return isVisible ? /*#__PURE__*/(0,react.createElement)(reach_portal_esm/* Portal */.h, null, /*#__PURE__*/(0,react.createElement)(TooltipContent, reach_tooltip_esm_extends({
    ref: forwardRef,
    label: label,
    "aria-label": DEPRECATED_ariaLabel,
    isVisible: isVisible
  }, props, {
    id: (0,reach_utils_make_id_esm/* makeId */.q)("tooltip", String(id))
  }))) : null;
});

if (false) {}
/**
 * TooltipContent
 *
 * We need a separate component so that useRect works inside the portal.
 *
 * @see Docs https://reach.tech/tooltip#tooltipcontent
 */


var TooltipContent = /*#__PURE__*/(0,react.forwardRef)(function TooltipContent(_ref4, forwardedRef) {
  var ariaLabel = _ref4.ariaLabel,
      realAriaLabel = _ref4["aria-label"],
      _ref4$as = _ref4.as,
      Comp = _ref4$as === void 0 ? "div" : _ref4$as,
      id = _ref4.id,
      isVisible = _ref4.isVisible,
      label = _ref4.label,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? positionTooltip : _ref4$position,
      style = _ref4.style,
      triggerRect = _ref4.triggerRect,
      props = reach_tooltip_esm_objectWithoutPropertiesLoose(_ref4, _excluded3);

  // The element that serves as the tooltip container has role tooltip.
  // https://www.w3.org/TR/wai-aria-practices-1.2/#tooltip When an app passes
  // an `aria-label`, we actually want to implement `role="tooltip"` on a
  // visually hidden element inside of the trigger. In these cases we want the
  // screen reader user to know both the content in the tooltip, but also the
  // content in the badge. For screen reader users, the only content announced
  // to them is whatever is in the tooltip.
  var hasAriaLabel = (realAriaLabel || ariaLabel) != null;
  var ownRef = (0,react.useRef)(null);
  var ref = (0,reach_utils_compose_refs_esm/* useComposedRefs */.e)(forwardedRef, ownRef);
  var tooltipRect = (0,reach_rect_esm/* useRect */.EL)(ownRef, {
    observe: isVisible
  });
  return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Comp, reach_tooltip_esm_extends({
    role: hasAriaLabel ? undefined : "tooltip"
  }, props, {
    ref: ref,
    "data-reach-tooltip": "",
    id: hasAriaLabel ? undefined : id,
    style: reach_tooltip_esm_extends({}, style, getStyles(position, triggerRect, tooltipRect))
  }), label), hasAriaLabel && /*#__PURE__*/(0,react.createElement)(VisuallyHidden, {
    role: "tooltip",
    id: id
  }, realAriaLabel || ariaLabel));
});

if (false) {} ////////////////////////////////////////////////////////////////////////////////


function getStyles(position, triggerRect, tooltipRect) {
  var haventMeasuredTooltipYet = !tooltipRect;

  if (haventMeasuredTooltipYet) {
    return {
      visibility: "hidden"
    };
  }

  return position(triggerRect, tooltipRect);
} // Default offset from the trigger (e.g., if the tooltip is positioned above,
// there will be 8px between the bottom of the tooltip and the top of the trigger).
// It feels awkward when it's perfectly aligned w/ the trigger


var OFFSET_DEFAULT = 8;
var positionTooltip = function positionTooltip(triggerRect, tooltipRect, offset) {
  if (offset === void 0) {
    offset = OFFSET_DEFAULT;
  }

  var _getDocumentDimension = getDocumentDimensions(),
      windowWidth = _getDocumentDimension.width,
      windowHeight = _getDocumentDimension.height;

  if (!triggerRect || !tooltipRect) {
    return {};
  }

  var collisions = {
    top: triggerRect.top - tooltipRect.height < 0,
    right: windowWidth < triggerRect.left + tooltipRect.width,
    bottom: windowHeight < triggerRect.bottom + tooltipRect.height + offset,
    left: triggerRect.left - tooltipRect.width < 0
  };
  var directionRight = collisions.right && !collisions.left;
  var directionUp = collisions.bottom && !collisions.top;
  return {
    left: directionRight ? triggerRect.right - tooltipRect.width + window.pageXOffset + "px" : triggerRect.left + window.pageXOffset + "px",
    top: directionUp ? triggerRect.top - offset - tooltipRect.height + window.pageYOffset + "px" : triggerRect.top + offset + triggerRect.height + window.pageYOffset + "px"
  };
};
/**
 * This is a workaround for using tooltips with disabled controls in Safari.
 * Safari fires `pointerenter` but does not fire `pointerleave`, and
 * `onPointerEventLeave` added to the trigger element will not work.
 *
 * TODO: We may remove or modiify this behavior in a future version. Direction
 * from WAI-ARIA needed for guidance on handling disabled triggers. Tooltips
 * must be accessible by keyboard, and disabled form controls are generally
 * excluded from the tab sequence.
 *
 * @see https://github.com/reach/reach-ui/issues/564
 * @see https://github.com/w3c/aria-practices/issues/128#issuecomment-588625727
 */

function useDisabledTriggerOnSafari(_ref5) {
  var disabled = _ref5.disabled,
      isVisible = _ref5.isVisible,
      ref = _ref5.ref;
  (0,react.useEffect)(function () {
    if (!(typeof window !== "undefined" && "PointerEvent" in window) || !disabled || !isVisible) {
      return;
    }

    var ownerDocument = (0,reach_utils_owner_document_esm/* getOwnerDocument */.r)(ref.current);

    function handleMouseMove(event) {
      if (!isVisible) {
        return;
      }

      if (event.target instanceof Element && event.target.closest("[data-reach-tooltip-trigger][data-state='tooltip-visible']")) {
        return;
      }

      send({
        type: TooltipEvents.GlobalMouseMove
      });
    }

    ownerDocument.addEventListener("mousemove", handleMouseMove);
    return function () {
      ownerDocument.removeEventListener("mousemove", handleMouseMove);
    };
  }, [disabled, isVisible, ref]);
} ////////////////////////////////////////////////////////////////////////////////

/**
 * Send an event to our state machine to find the next state from the current
 * state + action.
 *
 * It also manages lifecycles of the machine, (enter/leave hooks on the state
 * chart)
 *
 * @param event
 * @param payload
 */


function send(event) {
  var _transition = transition(state, event),
      value = _transition.value,
      context = _transition.context,
      changed = _transition.changed;

  if (changed) {
    state = {
      value: value,
      context: context
    };
    notify();
  }
}

function transition(currentState, event) {
  var stateDef = chart.states[currentState.value];
  var nextState = stateDef && stateDef.on && stateDef.on[event.type]; // Really useful for debugging
  // console.log({ event, state, nextState, contextId: context.id });
  // !nextState && console.log("no transition taken");

  if (!nextState) {
    return reach_tooltip_esm_extends({}, currentState, {
      changed: false
    });
  }

  if (stateDef && stateDef.leave) {
    stateDef.leave(currentState.context, event);
  }

  event.type;
      var payload = reach_tooltip_esm_objectWithoutPropertiesLoose(event, _excluded4); // TODO: Use actions instead of directly setting context


  var context = reach_tooltip_esm_extends({}, state.context, payload);

  var nextStateValue = typeof nextState === "string" ? nextState : nextState.target;
  var nextDef = chart.states[nextStateValue];

  if (nextDef && nextDef.enter) {
    nextDef.enter(currentState.context, event);
  }

  return {
    value: nextStateValue,
    context: context,
    changed: true
  };
}

function isTooltipVisible(id, initial) {
  return state.context.id === id && (initial ? state.value === TooltipStates.Visible : state.value === TooltipStates.Visible || state.value === TooltipStates.LeavingVisible);
} ////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ var reach_tooltip_esm = ((/* unused pure expression or super */ null && (Tooltip)));


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(70714);
;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/tooltip/index.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 192px;\n  position: absolute;\n  padding: 8px;\n  background: ",
        ";\n  border-radius: 4px;\n  color: ",
        ";\n  font-size: 14px;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background: ",
        ";\n  border-radius: 2px 0 0 0;\n  transform: translate(",
        "px, ",
        "px) rotate(45deg);\n  clip-path: polygon(0 0, 0 100%, 100% 0, 0 0);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var tipWidth = 16;
var tipHeight = 8;
function getStrongBackgroundColor(props) {
    var _color = props.color, color = _color === void 0 ? "black" : _color;
    switch(color){
        case "black":
            return "var(--coolGray-900)";
        case "teal":
        case "pink":
            return "var(--".concat(color, "-900)");
        default:
            return "var(--".concat(color, "-600)");
    }
}
function getFadedBackgroundColor(props) {
    var _color = props.color, color = _color === void 0 ? "black" : _color;
    switch(color){
        case "black":
            return "var(--coolGray-200)";
        case "orange":
        case "pink":
            return "var(--".concat(color, "-50)");
        default:
            return "var(--".concat(color, "-100)");
    }
}
function getBackgroundColor(props) {
    return (props.faded ? getFadedBackgroundColor : getStrongBackgroundColor)(props);
}
function getColor(props) {
    if (props.faded) {
        return getStrongBackgroundColor(props);
    }
    return "var(--white)";
}
var Popup = (0,styled_components_browser_esm/* default */.ZP)(TooltipPopup).withConfig({
    componentId: "sc-fa75ca09-0"
})(_templateObject(), getBackgroundColor, getColor);
var transformAfterRotate = (tipWidth - tipWidth / Math.SQRT2) / 2;
var Tip = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa75ca09-1"
})(_templateObject1(), tipWidth / Math.SQRT2, tipWidth / Math.SQRT2, getBackgroundColor, transformAfterRotate, transformAfterRotate);

;// CONCATENATED MODULE: ./node_modules/@demystdata/ui/tooltip/index.jsx









var centered = function(triggerRect, tooltipRect) {
    var triggerCenter = triggerRect.left + triggerRect.width / 2;
    var left = triggerCenter - tooltipRect.width / 2;
    var maxLeft = window.innerWidth - tooltipRect.width - 2;
    return {
        left: Math.min(Math.max(2, left), maxLeft) + window.scrollX,
        top: triggerRect.bottom + tipHeight + window.scrollY
    };
};
function tooltip_Tooltip(param) {
    var ariaLabel = param.ariaLabel, children = param.children, className = param.className, color = param.color, _faded = param.faded, faded = _faded === void 0 ? false : _faded, label = param.label;
    var ref = (0,_sliced_to_array/* default */.Z)(useTooltip(), 2), trigger = ref[0], tooltip = ref[1];
    var isVisible = tooltip.isVisible, triggerRect = tooltip.triggerRect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ react.cloneElement(children, trigger),
            isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(reach_portal_esm/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tip, {
                    color: color,
                    faded: faded,
                    style: triggerRect && {
                        left: triggerRect.left + triggerRect.width / 2 - tipWidth / 2,
                        top: triggerRect.bottom + window.scrollY
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tooltip), {
                "aria-label": ariaLabel,
                className: className,
                color: color,
                faded: faded,
                label: label,
                position: centered
            }))
        ]
    });
};
tooltip_Tooltip.propTypes = {
    /**
   * ARIA label.
   */ ariaLabel: (prop_types_default()).string,
    /**
   * Component to wrap the tooltip around.
   */ children: (prop_types_default()).node,
    /**
   * Tooltip class name.
   */ className: (prop_types_default()).string,
    /**
   * Tooltip color.
   */ color: prop_types_default().oneOf([
        "black",
        // Deprecated, but kept for backwards compatibility
        "red",
        "blue",
        "orange",
        "teal",
        "pink", 
    ]),
    /**
   * Whether tooltip background should be faded.
   */ faded: (prop_types_default()).bool,
    /**
   * Tooltip content.
   */ label: (prop_types_default()).node
};


/***/ })

}]);